// This file is automatically generated. Do not edit manually.

import { SalvosOrderSalesCommissionCalculationResult } from "src/api/generated/tenants/salvos/erp/sales/commission/model/salvosOrderSalesCommissionCalculationResult";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalvosSalesCommissionCalculationApi {
	export async function calculateOfferSalesCommission(args: {
		customerOfferId: number;
		salesCommissionId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/salvos/erp/sales/salesCommissions/calculateOfferSalesCommission",
			method: "POST",
			data: {
				customerOfferId: args.customerOfferId,
				salesCommissionId: args.salesCommissionId,
			},
		});
		return response as void;
	}

	export async function calculateOrderSalesCommission(args: {
		customerOrderId: number;
		salesCommissionId: number;
	}): Promise<SalvosOrderSalesCommissionCalculationResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/salvos/erp/sales/salesCommissions/calculateOrderSalesCommission",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				salesCommissionId: args.salesCommissionId,
			},
		});
		return response as SalvosOrderSalesCommissionCalculationResult;
	}
}
